/**
 * useProviderExamExport Hook
 * Custom hook for exporting a provider's linked exams to Excel
 */

import { useState, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import providerExamService from '../services/providerExamService';
import { isApiError } from '../types/common';

interface UseProviderExamExportResult {
  exporting: boolean;
  exportLinked: (providerId: number, filename?: string) => Promise<void>;
}

export const useProviderExamExport = (): UseProviderExamExportResult => {
  const { enqueueSnackbar } = useSnackbar();
  const [exporting, setExporting] = useState(false);

  const exportLinked = useCallback(async (providerId: number, filename = 'exames-prestador.xlsx') => {
    try {
      setExporting(true);
      const blob = await providerExamService.exportLinkedExams(providerId);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url; link.download = filename;
      document.body.appendChild(link); link.click(); document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      enqueueSnackbar('Exames exportados com sucesso', { variant: 'success' });
    } catch (err: unknown) {
      const msg = isApiError(err) ? err.message : err instanceof Error ? err.message : 'Erro ao exportar exames';
      enqueueSnackbar(msg, { variant: 'error' });
    } finally {
      setExporting(false);
    }
  }, [enqueueSnackbar]);

  return { exporting, exportLinked };
};
